import React from 'react'
import PropTypes from 'prop-types'
import { PaperStyle } from './PaperAutoComplete.style'

const PaperAutoComplete = React.forwardRef(function PaperAutoComplete(props, ref) {
  const { children, ...other } = props

  return (
    <PaperStyle
      role="listbox"
      ref={ref}
      {...other}
      style={{ padding: 0, margin: 0, listStyle: 'none' }}
    >
      {children}
    </PaperStyle>
  )
})

PaperAutoComplete.displayName = 'PaperAutoComplete'
PaperAutoComplete.propTypes = {
  children: PropTypes.any
}

export default PaperAutoComplete
